/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'
import {REGEX} from '../../constants'
import {useXSSProtection} from './../../hooks/use-xss-protection'
import {useToast} from '../../hooks/use-toast'

export default function useResetPasswordFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const toast = useToast()
    const {formatMessage} = useIntl()
    const {validateField} = useXSSProtection()

    const fields = {
        email: {
            name: `${prefix}email`,
            label: formatMessage({
                defaultMessage: 'Email Address',
                id: 'use_reset_password_fields.label.email'
            }),
            placeholder: 'you@email.com',
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_reset_password_fields.error.required_email'
                }),
                pattern: {
                    value: REGEX.EMAIL,
                    message: formatMessage({
                        defaultMessage: 'Please enter a valid email address.',
                        id: 'use_reset_password_fields.error.invalid_email'
                    })
                },
                validate: (value) => validateField(toast, value, 'resetpassword-form', 'email')
            },
            error: errors[`${prefix}email`],
            control
        }
    }

    return fields
}
